import type { ComputedRef } from 'vue'
import type { Maybe, Setting } from '@/types'

import { computed, nextTick, onMounted } from 'vue'

import { useCustomerSettingsStore } from '@/stores/customer/settings'

export const useCustomerSettings = <T>(
  name: Setting['name'],
  key?: keyof T
) => {
  onMounted(() => checkSettings())

  const settingsStore = useCustomerSettingsStore()
  const currentSettings = computed(() =>
    settingsStore.getItemByName(name)
  ) as ComputedRef<Maybe<Setting<T>>>

  async function checkSettings() {
    if (!currentSettings.value) {
      await settingsStore.fetchItemByName(name)
      await nextTick()
    }

    return key
      ? currentSettings.value?.value[key]
      : currentSettings.value?.value
  }

  return { currentSettings, checkSettings }
}
